// External
import { useMutation, useQueryClient } from '@tanstack/react-query';
// Shared components
import { toast } from '@/hooks/use-toast';
import { SUCCESS_TOAST_DURATION } from '@/react/constants';
// Hooks
import { useTranslation } from '../useTranslation';
// API
import { activateResaleItem, deactivateResaleItem, resaleItemsQueryKeys } from '@api/resaleItems';

export function useUpdateResaleItemStatus() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({ id, active }: { id: number; active: boolean }) => {
      return active ? activateResaleItem(id) : deactivateResaleItem(id);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: resaleItemsQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: resaleItemsQueryKeys.detail(variables.id) });

      toast({ description: t('toast.status_updated'), duration: SUCCESS_TOAST_DURATION });
    },
    onError: (error) => {
      toast({
        description: error.message || t('toast.status_update_error'),
        variant: 'destructive',
      });
    },
  });
}
